import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { TextField } from "@mui/material"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import moment from "moment"

export const MyDateInput = ({ label, name, date, handleChangeElement }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
      <DatePicker
        label={label}
        value={date}
        onChange={(newValue) =>
          handleChangeElement({
            target: {
              name,
              value: moment(newValue.format("YYYY-MM-DD")).format("YYYY-MM-DD"),
            },
          })
        }
        renderInput={(params) => <TextField {...params} fullWidth />}
      />
    </LocalizationProvider>
  )
}
